import React, { ReactNode } from 'react';

interface IStep {
    count: number;
    title: string;
    subTitle?: string;
    children: ReactNode;
    detailedInfo?: string;
}

const Step: React.FC<IStep> = ({ count, title, subTitle = '', children, detailedInfo = '' }) => {
    return (
        <div className="mb-5 border-b-2 border-b-blueGray-200 last:border-b-0 last:mb-10">
            <div className="relative flex items-center py-2 text-p1">
                <div className="relative z-10 inline-flex items-center justify-center mr-5 bg-white border rounded-full w-[50px] h-[50px] border-blueGray-200 min-w-[50px] text-h2">
                    {count}
                </div>
                <div>
                    <div>{title}</div>
                    {subTitle && <div className="text-blueGray-500 text-p2">{subTitle}</div>}
                </div>
            </div>

            <div className="py-5 pl-16">
                {children}
                {detailedInfo && (
                    <p className="mb-3 whitespace-pre-line text-blueGray-500 text-p1">
                        {detailedInfo}
                    </p>
                )}
            </div>
        </div>
    );
};

export default Step;
